import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useFacebookSellerStore = defineStore({
  id: 'facebookSellers',
  actions: {
    async getFacebookSellers(type) {
      const {data} = await axios.get('facebook/sellers', {params: {type}})

      return data
    },
    async deleteFacebookSeller(hash) {
      await axios.delete(`facebook/sellers/${hash}`)
    },
  },
})